import { array, arrayOf, shape, string } from 'prop-types'

const navItemShape = {
  caption: string.isRequired,
  path: string.isRequired,
}

export const navItemType = shape(navItemShape)

export const upNavTreeType = arrayOf(shape(navItemShape))

export const downNavTreeType = arrayOf(
  shape({
    ...navItemShape,
    down: array,
  })
)
